import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
name: 'afterClassify',
components: {
XHeader,
XButton
},
data () {
return {
isAscendingOrder: false,
designClass: true
}
},
methods: {
toggleSort () {
this.isAscendingOrder = !this.isAscendingOrder
},
toggleDesign () {
this.designClass = !this.designClass
},
classify () {
this.$router.push('/classify')
},
login () {
this.$router.push('/login')
}
},
created () {

}
}



// WEBPACK FOOTER //
// ./src/views/afterClassify/script.js